import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=0ed9ac23&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=0ed9ac23&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9ac23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed9ac23')) {
      api.createRecord('0ed9ac23', component.options)
    } else {
      api.reload('0ed9ac23', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=0ed9ac23&scoped=true", function () {
      api.rerender('0ed9ac23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/sidebar.vue"
export default component.exports